module.exports = __webpack_public_path__ + "assets/img/light-panel.cfea9b3a.png";